"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiConfigurationMessages = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.KpiConfigurationMessages = function (props) {
    var numberOfAlerts = props.numberOfAlerts;
    if (numberOfAlerts) {
        return (react_1.default.createElement("div", { className: "warning s-alert-edit-warning" },
            react_1.default.createElement(sdk_ui_kit_1.Message, { type: "warning" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "configurationPanel.breakAlertWarning", values: { numAlerts: numberOfAlerts } }))));
    }
    return null;
};
//# sourceMappingURL=KpiConfigurationMessages.js.map